module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-result-warp column"
  }, [_c('div', {
    staticClass: "game-result-header"
  }, [_c('div', {
    staticClass: "my-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.toMy()
      }
    }
  }, [_vm._v("戻る")]), _vm._v(" "), _c('div', {
    staticClass: "my-topic"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.2rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("テーマ:")]), _c('span', {
    staticClass: "my-topic-theme"
  }, [_vm._v(_vm._s(_vm.room.theme))])]), _vm._v(" "), _c('div', {
    staticClass: "title-box column column-center"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("結果")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("プレイ時間：" + _vm._s(_vm.users.length > 0 ? _vm.formatSeconds(_vm.users[0].turnTime) : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "game-result-info-box column"
  }, _vm._l((_vm.users), function(item, index) {
    return _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "tig"
    }, [_vm._v(_vm._s(item.userRole == 1 ? 'ファシリテーター' : 'プレイヤー'))]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), (_vm.plan == '法人プラン') ? _c('el-button', {
      staticClass: "details-btn",
      on: {
        "click": function($event) {
          return _vm.fenxi(item)
        }
      }
    }, [_vm._v("チャート分析をみる")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "cards-lists row-flex row"
    }, [_vm._l((item.urls), function(item2, index2) {
      return (item.isShowCard == 1) ? _c('el-image', {
        key: index2,
        staticClass: "card",
        attrs: {
          "src": item2,
          "fit": "contain"
        }
      }) : _vm._e()
    }), _vm._v(" "), _vm._l((item.urls), function(item2, index2) {
      return (item.isShowCard == 0) ? _c('el-image', {
        key: index2,
        staticClass: "card",
        attrs: {
          "src": _vm.cardsBack,
          "fit": "contain"
        }
      }) : _vm._e()
    })], 2)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f75e3bd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/room/resu.vue
// module id = 904
// module chunks = 1